// extracted by mini-css-extract-plugin
module.exports = {"component":"quick-link-card_component__mrWHE","icon":"quick-link-card_icon__dvLLz","text":"quick-link-card_text__8_QhF"};